import { useEffect, useState } from "react";
import { API } from "@/lib/api";

function upsert(selector, tag, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export function useTeamManifest(slug, app, color, title, version = "") {
  useEffect(() => {
    if (!slug) {
      return;
    }
    upsert('link[rel="manifest"]', "link", { rel: "manifest", href: `${API}/public/teams/${slug}/manifest.json?app=${app}` });
    upsert('link[rel="apple-touch-icon"]', "link", { rel: "apple-touch-icon", href: `${API}/public/teams/${slug}/icon.png?app=${app}&size=192&v=${version}` });
    if (color) {
      upsert('meta[name="theme-color"]', "meta", { name: "theme-color", content: color });
    }
    if (title) {
      document.title = title;
      upsert('meta[name="apple-mobile-web-app-title"]', "meta", { name: "apple-mobile-web-app-title", content: title });
    }
  }, [slug, app, color, title, version]);
}

export function useInstallPrompt() {
  const [evt, setEvt] = useState(window.__pwaPrompt || null);
  const installed = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
  const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

  useEffect(() => {
    const onReady = () => setEvt(window.__pwaPrompt);
    window.addEventListener("pwa-ready", onReady);
    return () => window.removeEventListener("pwa-ready", onReady);
  }, []);

  const install = async () => {
    if (!evt) return false;
    evt.prompt();
    await evt.userChoice;
    window.__pwaPrompt = null;
    setEvt(null);
    return true;
  };

  return { canPrompt: !!evt, install, installed, isIOS };
}
